// Copyright (c) Microsoft. All rights reserved.

import { Button, Text, makeStyles, shorthands, tokens } from '@fluentui/react-components';
import React from 'react';
import { useChat } from '../../../libs/hooks';

const useClasses = makeStyles({
    root: {
        textAlign: 'right',
        width: '100%',
        maxWidth: '105em',
        ...shorthands.margin(tokens.spacingVerticalNone, tokens.spacingHorizontalM),
    },
});

export const ChatContinueBanner: React.FC = () => {
    const classes = useClasses();

    const chat = useChat();

    const onNewChat = () => {
        void chat.createChat();
    };

    return (
        <div className={classes.root}>
            <Text italic size={300}>
                Stelle eine weitere Frage zum Thema oder starte einen <Button onClick={onNewChat}>neuen Chat</Button>
            </Text>
        </div>
    );
};
